import { NumberInput, type NumberInputProps } from '@mantine/core';
import { FIELD_STYLES } from './InputWithLabel';

export function NumberInputWithLabel({ ...props }: NumberInputProps) {
  return <NumberInput {...props} styles={FIELD_STYLES} />;
}
